var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('operationCenter',{ref:"operationCenter",attrs:{"operationList":_vm.operationList}})}
var staticRenderFns = []

export { render, staticRenderFns }